import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { AppModalService } from '../../../shared/services/app-modal.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss'],
})
export class ForgotComponent {
  loginForm: FormGroup;

  messageText = '';

  messageType = '';

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private messageModalService: AppModalService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
  ) {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,5}$/),
        Validators.required,
      ]),
    });
  }

  restorePassword() {
    if (
      !this.loginForm.controls.email.errors?.pattern &&
      !this.loginForm.controls.email.errors?.required
    ) {
      this.spinner.show();
      this.authService.forgotPassword(this.loginForm.value.email).subscribe((resp: any) => {
        if (resp.status === 'error') {
          this.messageType = 'danger';
          this.messageText = resp.data.messages;
        } else {
          this.messageModalService.open({
            title: 'A password recovery email has been sent to your email',
            canClose: true,
          });
          this.router.navigate(['/']);
        }
        this.spinner.hide();
      });
    }
  }

  closeAlert() {
    this.messageType = '';
    this.messageText = '';
  }

  toLowerCase() {
    this.loginForm.get('email')?.setValue(this.loginForm.controls.email.value.toLowerCase());
  }
}
